import React, { CSSProperties } from 'react';

const MULTIPLIER = 8;
const BASE_INDENT = 4;

export function Indent({ depth, ...rest }: { depth: number } & React.HTMLAttributes<HTMLDivElement>) {
	const style: CSSProperties = {
		paddingLeft: `${MULTIPLIER * depth + BASE_INDENT}px`,
	};

	return <div {...rest} style={style} />;
}
